import { defineStore } from 'pinia';
import auth from '@/utils/auth';
import { Mrohistory } from '@/utils/cookiesKey';
import { getApp } from '@/api/appSetting';
import { usePermissionStore } from './routers';
import { MENU_MODULE } from 'mroshopcommon';
import { userInfo } from './userInfo';
import { checkRole } from '@/utils/permission'; // 权限判断函数

export const shopEnum = {
  inner: {
    key: 'inner',
    value: '中小企业商城',
  },
  outer: {
    key: 'outer',
    value: '数智化商城',
  },
  point: {
    key: 'point',
    value: '积分商城',
  },
};

export const appInfo = defineStore('appInfo', {
  state: () => {
    return {
      //全局监听的滚动条
      scrollTop: 0,
      //存在cookie里的搜索历史
      searchHistory: auth.getTokenByKey(Mrohistory) ? JSON.parse(auth.getTokenByKey(Mrohistory)) : [],
      //后台定义的网站设置
      appSetting: {
        grayMode: false,
        showPhone: '400-822-0337',
        phone: '4008220337',
        appName: '智电云商',
        icp: '浙ICP备2021033845号-2',
        headerLogo: '',
        footerLogo: '',
        slogn: '数字化采购服务平台',
        workTime: '周一到周五 8:00-17:00',
        address: '浙江省温州市乐清市柳市镇长东路1号正泰物联网传感园8幢3楼',
        longitudeAndLatitude: '120.877721,28.01553',
        portalQR: '',
        wxQR: '',
        quickLink: [],
        serveList: [],
        activiteCates: [],
      },
      //是否是内部
      isInner: false,
      //前往登录或注册页之前的页面地址
      redirectUrl: '',
      isRedirectUrl: true,
      //可用的商品列表
      shopList: [],
      // 所有商城列表
      shops: [
        {
          name: shopEnum.outer.value,
          mallIndex: shopEnum.outer.key,
          payLoad: {
            sopFlag: true,
            hostId: 1,
            pointFlag: 0,
            exname: shopEnum.outer.value,
          },
        },
        {
          name: shopEnum.inner.value,
          mallIndex: shopEnum.inner.key,
          payLoad: {
            sopFlag: false,
            innerFlag: 1,
            hostId: userInfo().defaultHostId,
            exname: shopEnum.inner.value,
          },
        },
        {
          name: shopEnum.point.value,
          mallIndex: shopEnum.point.key,
          payLoad: {
            sopFlag: true,
            zoneId: 3,
            hostId: 1,
            pointFlag: 1,
            exname: shopEnum.point.value,
          },
        },
      ],
    };
  },
  getters: {
    userRoute: state => {
      const chache = useRouter()
        .options.routes.find(item => item.path == '/usercenter')
        ?.children[0].children.sort((a, b) => (a.meta?.sort ?? 0) - (b.meta?.sort ?? 0));
      const arr = [];
      chache.forEach(item => {
        if (showUserRoute(item, state)) {
          arr.push(item);
        }
      });
      return arr;
    },
    topUserRoute: getters => {
      console.log('getters.userRoute: ', getters.userRoute);
      return userRouteToTree(getters.userRoute.filter(item => item.meta?.showTop));
    },
    userCenterRouter: getters => {
      return userRouteToTree(getters.userRoute);
    },
    //  显示商家中心
    showShopCenter: () => {
      return usePermissionStore().sidebarRouters.some(item => item.systemType == MENU_MODULE.SUPPLIERFRONT);
    },

    // 显示销售中心
    showEntertainment: () => {
      return usePermissionStore().sidebarRouters.some(item => item.systemType == MENU_MODULE.DISTRIBUTORFRONT);
    },
    // 获取商家中心第一条路由
    shopCenterFirstRoute: () => {
      const routers = usePermissionStore().sidebarRouters.filter(
        item => item.systemType == MENU_MODULE.SUPPLIERFRONT && !item.hidden
      );
      console.log('shopCenterFirstRouterouters: ', usePermissionStore().sidebarRouters);

      return handleFirstRoute(routers);
    },
    // 获取销售中心第一条路由
    entertainmentFirstRoute: () => {
      const routers = usePermissionStore().sidebarRouters.filter(
        item => item.systemType == MENU_MODULE.DISTRIBUTORFRONT
      );
      console.log('entertainmentFirstRoute: ', routers);

      return handleFirstRoute(routers);
    },
    // 是否隐藏价格
    isHideMoney: state => {
      const userStores = userInfo();
      return userStores.roles.includes('visitProcure') && state.isInner;
    },
    // 当前域名是否在数智化商城
    isShopHost: () => {
      return location.host == import.meta.env.VITE_APP_DOMAIN.replace(/^(https?:|)\/\//, '');
    },
    // 当前域名是否在中小企业商城
    isSmallCompanyHost: () => {
      return location.host == import.meta.env.VITE_APP_DOMAIN_INNER.replace(/^(https?:|)\/\//, '');
    },
    // 当前域名是否在积分商城
    isPointHost: () => {
      return location.host == import.meta.env.VITE_APP_DOMAIN_POINT.replace(/^(https?:|)\/\//, '');
    },

    // 当前域名所在商城mallIndex
    curShopInfo: getters => {
      if (getters.isShopHost) {
        return getters.shops.find(item => item.mallIndex == shopEnum.outer.key);
      } else if (getters.isSmallCompanyHost) {
        return getters.shops.find(item => item.mallIndex == shopEnum.inner.key);
      } else if (getters.isPointHost) {
        return getters.shops.find(item => item.mallIndex == shopEnum.point.key);
      }
    },
    curShopMallIndex: getters => {
      return getters?.curShopInfo?.mallIndex;
    },
    shopName: state => {
      switch (location.host) {
        case import.meta.env.VITE_APP_DOMAIN.replace(/^(https?:|)\/\//, ''):
          return '数智化商城';
          break;
        case import.meta.env.VITE_APP_DOMAIN_INNER.replace(/^(https?:|)\/\//, ''):
          return '中小企业商城';
          break;
        case import.meta.env.VITE_APP_DOMAIN_POINT.replace(/^(https?:|)\/\//, ''):
          return '积分商城';
          break;
        default:
          break;
      }
    },
    seoShopName: state => {
      switch (location.host) {
        case import.meta.env.VITE_APP_DOMAIN.replace(/^(https?:|)\/\//, ''):
          return state.appSetting.appName + ' · 数智化商城';
          break;
        case import.meta.env.VITE_APP_DOMAIN_INNER.replace(/^(https?:|)\/\//, ''):
          return state.appSetting.appName + ' · 中小企业商城';
          break;
        case import.meta.env.VITE_APP_DOMAIN_POINT.replace(/^(https?:|)\/\//, ''):
          return state.appSetting.appName + ' · 积分商城';
          break;
        default:
          break;
      }
    },
    // 埋点专用
    pointShopName: state => {
      switch (location.host) {
        case import.meta.env.VITE_APP_DOMAIN.replace(/^(https?:|)\/\//, ''):
          return '数智化商城';
          break;
        case import.meta.env.VITE_APP_DOMAIN_INNER.replace(/^(https?:|)\/\//, ''):
          return '中小企业商城';
          break;
        case import.meta.env.VITE_APP_DOMAIN_POINT.replace(/^(https?:|)\/\//, ''):
          return '积分商城';
          break;
        default:
          break;
      }
    },
  },
  actions: {
    addHistory(key) {
      const index = this.searchHistory.findIndex(item => item.value == key);
      if (index !== -1) {
        this.searchHistory.splice(index, 1);
      }
      this.searchHistory.unshift({ value: key });
      if (this.searchHistory.length > 5) {
        this.searchHistory.splice(5, 100);
      }
      auth.setTokenByKey(Mrohistory, JSON.stringify(this.searchHistory));
    },
    removeHistory(key) {
      const index = this.searchHistory.findIndex(item => item.value == key.value);
      this.searchHistory.splice(index, 1);
      auth.setTokenByKey(Mrohistory, JSON.stringify(this.searchHistory));
    },
    getAppSet() {
      getApp().then(res => {
        const chache = JSON.parse(res.data.content);
        Object.keys(this.appSetting).forEach(key => {
          if (chache[key]) {
            this.appSetting[key] = chache[key];
          }
        });
      });
    },
    changeInner(url = '/') {
      if (this.isInner) {
        location.replace(`${import.meta.env.VITE_APP_DOMAIN}${url}`);
      } else {
        useRouter()
          .push(url)
          .then(() => {
            location.reload();
          });
      }
    },
  },
});

function handleFirstRoute(routers, path = '') {
  // console.log('routers123: ', routers);
  // 排除掉隐藏的路由 hidden=true
  routers = routers.filter(item => !item.hidden);
  // 暂时解决商家中心和销售中心的问题
  if (routers?.length) {
    path += routers[0]?.path;
  }
  if (routers[0]?.children) {
    return handleFirstRoute(routers[0]?.children, path + (path.endsWith('/') ? '' : '/'));
  }

  return path;
}
//个人中心转成树结构
function userRouteToTree(route) {
  const arr = [];
  route.forEach(item => {
    if (item.meta?.partant && arr.findIndex(el => el.title == item.meta.partant) == -1) {
      arr.push({ title: item.meta.partant, name: item.name, list: [] });
    }
    arr.forEach(iitem => {
      if (item.meta?.partant && iitem.title == item.meta.partant) {
        iitem.list.push({ title: item.meta.title, name: item.name, meta: item.meta });
      }
    });
  });
  return arr;
}

//判断菜单是否显示
function showUserRoute(item, state) {
  if (item?.meta?.rules) {
    return checkRole(item.meta.rules);
  } else {
    if (item?.meta?.hidden) {
      if (item.meta.hidden == 'all') {
        return false;
      } else {
        if (item.meta.hidden == 'in') {
          return !state.isInner;
        }
        if (item.meta.hidden == 'out') {
          return state.isInner;
        }
      }
    } else {
      return true;
    }
    return true;
  }
}
